import { type FC, type Ref } from "react";
import { type ShopWorkCassetteProps } from "@userFrontend/features/publication/types/Cassettes";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { Icon } from "@root/shared/components/Icon";
import { Salaries } from "@userFrontend/features/publication/components/Salaries";
import { EntryOrScoutButton } from "@userFrontend/features/publication/components/WorkWithShopWorkCassette/uiParts/EntryOrScoutButton";
import { type ModalLinkParams } from "@userFrontend/features/publication/components/WorkWithShopWorkCassette/type";
import * as styles from "./styles.css";

type Props = {
  handleClickLink: (params: ModalLinkParams) => void;
  linkGaAction?: string;
  scoutGaAction: string;
  entryGaAction: string;
  gaLabel: string;
  cassetteRef: Ref<HTMLDivElement>;
} & Omit<ShopWorkCassetteProps, "docId">;

export const Presentation: FC<Props> = ({
  imgSrc,
  url,
  title,
  shopName,
  shopAddress: { prefecture, city, station },
  employmentAndSalaryType,
  enterableFlag,
  entriedFlag,
  scoutedFlag,
  workCode,
  scoutedEntryUrl,
  query,
  entryUrl,
  handleClickLink,
  linkGaAction,
  scoutGaAction,
  entryGaAction,
  gaLabel,
  cassetteRef,
}) => (
  <div
    className={styles.outer}
    onClick={(e) => handleClickLink({ url, query, event: e, gaAction: linkGaAction, gaLabel })}
    onKeyDown={(e) => handleClickLink({ url, query, event: e, gaAction: linkGaAction, gaLabel })}
    role="button"
    tabIndex={0}
    ref={cassetteRef}
  >
    <a
      href={url}
      className={styles.link}
      onClick={(e) => {
        e.stopPropagation();
        handleClickLink({ url, query, event: e, gaAction: linkGaAction, gaLabel });
      }}
      data-ga-action={linkGaAction}
      data-ga-label={gaLabel}
    >
      <div className={styles.imageAndTitle}>
        <div className={styles.imageOuter}>
          <LazyLoadImage src={imgSrc} alt="" width={657} height={370} />
        </div>
        <p className={styles.shopName}>{shopName}</p>
      </div>
      <p className={styles.title}>
        <span className={styles.textLink}>{title}</span>
      </p>
      <div className={styles.salariesOuter}>
        <Salaries employmentAndSalaryType={employmentAndSalaryType} shopName={shopName} />
      </div>
      <p className={styles.location}>
        <span className={styles.locationIconOuter}>
          <Icon name="location" />
        </span>
        {prefecture} {city}
        {station.length > 0 && `(${station})`}
      </p>
    </a>
    <div className={styles.buttonOuter} onClick={(e) => e.stopPropagation()} aria-hidden="true">
      <EntryOrScoutButton
        size="small"
        entriedFlag={entriedFlag}
        enterableFlag={enterableFlag}
        scoutedFlag={scoutedFlag}
        scoutedEntryUrl={scoutedEntryUrl}
        workCode={workCode}
        scoutGaAction={scoutGaAction}
        scoutGaLabel={gaLabel}
        query={query}
        entryUrl={entryUrl}
        entryGaAction={entryGaAction}
        entryGaLabel={gaLabel}
        handleClickLink={handleClickLink}
      />
    </div>
  </div>
);
